module.exports = __webpack_public_path__ + "images/9808f2ae53fdbc8c05922435d7b5de00-guesthouse.jpg";